import { render, staticRenderFns } from "./AutomationDetail.vue?vue&type=template&id=c2969068&scoped=true"
import script from "./AutomationDetail.vue?vue&type=script&lang=js"
export * from "./AutomationDetail.vue?vue&type=script&lang=js"
import style0 from "./AutomationDetail.vue?vue&type=style&index=0&id=c2969068&prod&scoped=true&lang=css"
import style1 from "./AutomationDetail.vue?vue&type=style&index=1&id=c2969068&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2969068",
  null
  
)

export default component.exports